import localStorageKeys from './localStorageKeys'

const localStorageManager = {
    set: (name, data) => {
        localStorage.setItem(name, JSON.stringify(data))
    },
    get: name => {
        return JSON.parse(localStorage.getItem(name))
    }
}

const setCustomerData = data => {
    localStorageManager.set('customer', data)
}

const setTeamData = data => {
    localStorageManager.set(localStorageKeys.TEAM, data)
}

const getPreviousTestAlerts = () => localStorageManager.get(localStorageKeys.tests) || []

const getCurrentTest = (channel, isTeamChannel) => {
    const previousTestAlerts = getPreviousTestAlerts()
    return previousTestAlerts.find(item => item?.priority === channel?.priority && item?.isTeamChannel === isTeamChannel)
}

export {setCustomerData, setTeamData, getPreviousTestAlerts, getCurrentTest}

export default localStorageManager
